import {
  ContractOrderOutputListDto,
  ContractOrderSFSearchInputDto,
  FilterDtoStatoEnum,
  FilterProjectMonthDto,
  FilterProjectMonthValuesDto,
  OrderSFSearchFilterDto,
  ProjectMonthDto,
} from '@api/client';
import { createReducer } from '@reduxjs/toolkit';
import {
  getCdgFilters,
  getCdgProjects,
  getClFilters,
  getClProjects,
  getPlFilters,
  getPlProjects,
  saveCdgFiltersUsed,
  saveClFiltersUsed,
  savePlFiltersUsed,
  searchClOrders,
  getClOrderOptions,
  saveClFiltersOrdersUsed,
  searchClOrderSfDetail,
  resetClOrderDetail,
} from './actions';

const defaultStatesPl = [
  FilterDtoStatoEnum.ReportingClosed,
  FilterDtoStatoEnum.WorkInProgress,
  // FilterDtoStatoEnum.WorkInProgressDraft,
];

const defaultStatesCl = [
  FilterDtoStatoEnum.ControlloCl,
  FilterDtoStatoEnum.ReportingClosed,
  FilterDtoStatoEnum.WorkInProgress,
  // FilterDtoStatoEnum.WorkInProgressDraft,
];

const defaultStatesCdg = [FilterDtoStatoEnum.ControlloCdg, FilterDtoStatoEnum.ReportingClosed];

interface InitialState {
  filtersCdg: FilterProjectMonthValuesDto | null | undefined;
  cdgProjects: ProjectMonthDto[];
  filtersCdgUsed: FilterProjectMonthDto | null | undefined;
  filtersCl: FilterProjectMonthValuesDto | null | undefined;
  clProjects: ProjectMonthDto[];
  filtersClUsed: FilterProjectMonthDto | null | undefined;
  filtersPl: FilterProjectMonthValuesDto | null | undefined;
  plProjects: ProjectMonthDto[];
  filtersPlUsed: FilterProjectMonthDto | null | undefined;
  /* CL Orders */
  clOrders: ContractOrderOutputListDto | null | undefined;
  clOrderOptions: OrderSFSearchFilterDto | null | undefined;
  filtersClOrdersUsed: ContractOrderSFSearchInputDto | null | undefined;
  clOrderSfDetail: ContractOrderOutputListDto | null | undefined;
}

const initialState: InitialState = {
  filtersCdg: null,
  cdgProjects: [],
  filtersCdgUsed: {
    stati: defaultStatesCdg,
  },
  filtersCl: null,
  clProjects: [],
  filtersClUsed: {
    stati: defaultStatesCl,
  },
  filtersPl: null,
  plProjects: [],
  filtersPlUsed: {
    stati: defaultStatesPl,
  },
  /* CL Orders */
  clOrders: null,
  clOrderOptions: null,
  filtersClOrdersUsed: {
    paging: { page: 0, size: 20 },
  },
  clOrderSfDetail: null,
};

export const managementToolsReducer = createReducer(initialState, (builder) => {
  builder
    /* #################### CDG #################### */
    .addCase(getCdgFilters.fulfilled, (state, action) => {
      state.filtersCdg = action.payload;
    })
    .addCase(getCdgProjects.fulfilled, (state, action) => {
      state.cdgProjects =
        action.payload?.projectList?.sort((a, b) => (Number(a.intranetId)! > Number(b.intranetId)! ? 1 : -1)) || [];
    })
    .addCase(saveCdgFiltersUsed, (state, action) => {
      state.filtersCdgUsed = action.payload;
    })
    /* #################### CL #################### */
    .addCase(getClFilters.fulfilled, (state, action) => {
      state.filtersCl = action.payload;
    })
    .addCase(getClProjects.fulfilled, (state, action) => {
      state.clProjects =
        action.payload?.projectList?.sort((a, b) => (Number(a.intranetId)! > Number(b.intranetId)! ? 1 : -1)) || [];
    })
    .addCase(saveClFiltersUsed, (state, action) => {
      state.filtersClUsed = action.payload;
    })
    /* #################### CL ORDERS #################### */
    .addCase(searchClOrders.fulfilled, (state, action) => {
      state.clOrders = action.payload;
    })
    .addCase(getClOrderOptions.fulfilled, (state, action) => {
      state.clOrderOptions = action.payload;
    })
    .addCase(saveClFiltersOrdersUsed, (state, action) => {
      state.filtersClOrdersUsed = action.payload;
    })
    .addCase(searchClOrderSfDetail.fulfilled, (state, action) => {
      state.clOrderSfDetail = action.payload;
    })
    .addCase(resetClOrderDetail, (state) => {
      state.clOrderSfDetail = null;
    })

    /* #################### PL #################### */
    .addCase(getPlFilters.fulfilled, (state, action) => {
      state.filtersPl = action.payload;
    })
    .addCase(getPlProjects.fulfilled, (state, action) => {
      state.plProjects =
        action.payload?.projectList?.sort((a, b) => (Number(a.intranetId)! > Number(b.intranetId)! ? 1 : -1)) || [];
    })
    .addCase(savePlFiltersUsed, (state, action) => {
      state.filtersPlUsed = action.payload;
    });
});
